module.exports = __webpack_public_path__ + "img/ford-logo.070fbd98.png";